import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Key, Check } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { API_BASE as API } from '../lib/apiBase';


export default function ForgotPasswordPage() {
  const { lang } = useLang();
  const [step, setStep] = useState('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const requestReset = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      setMessage(data.message);
      setStep('code');
    } catch { setError('Error de conexion'); }
    setLoading(false);
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) { setError(lang === 'es' ? 'Minimo 8 caracteres' : 'Minimum 8 characters'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code, new_password: newPassword })
      });
      const data = await res.json();
      if (res.ok) { setStep('done'); setMessage(data.message); }
      else setError(data.detail);
    } catch { setError('Error de conexion'); }
    setLoading(false);
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-pulse-muted text-sm mb-6 hover:text-white">
          <ArrowLeft size={16} /> {lang === 'es' ? 'Volver al login' : 'Back to login'}
        </Link>

        <div className="bg-pulse-surface border border-pulse-border rounded-2xl p-8">
          <h1 className="font-heading font-bold text-2xl mb-2 text-center">{lang === 'es' ? 'Recuperar Contrasena' : 'Reset Password'}</h1>

          {step === 'email' && (
            <form onSubmit={requestReset} className="space-y-4 mt-6">
              <p className="text-sm text-pulse-muted text-center">{lang === 'es' ? 'Introduce tu email y te enviaremos un codigo' : 'Enter your email and we will send you a code'}</p>
              <div className="relative">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-pulse-muted" />
                <input data-testid="reset-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" required className="w-full bg-pulse-elevated border border-pulse-border rounded-xl pl-11 pr-4 py-3 text-sm focus:ring-2 focus:ring-cyan-500 focus:outline-none" />
              </div>
              {error && <p className="text-red-400 text-xs">{error}</p>}
              <button type="submit" disabled={loading} className="w-full bg-pulse-primary text-black py-3 rounded-xl font-bold text-sm disabled:opacity-50">{loading ? '...' : (lang === 'es' ? 'Enviar codigo' : 'Send code')}</button>
            </form>
          )}

          {step === 'code' && (
            <form onSubmit={resetPassword} className="space-y-4 mt-6">
              {message && <p className="text-green-400 text-xs text-center">{message}</p>}
              <div className="relative">
                <Key size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-pulse-muted" />
                <input data-testid="reset-code" type="text" value={code} onChange={e => setCode(e.target.value)} placeholder={lang === 'es' ? 'Codigo de 6 digitos' : '6-digit code'} required className="w-full bg-pulse-elevated border border-pulse-border rounded-xl pl-11 pr-4 py-3 text-sm focus:ring-2 focus:ring-cyan-500 focus:outline-none" />
              </div>
              <input data-testid="new-password" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder={lang === 'es' ? 'Nueva contrasena (min 8 caracteres)' : 'New password (min 8 chars)'} required minLength={8} className="w-full bg-pulse-elevated border border-pulse-border rounded-xl px-4 py-3 text-sm focus:ring-2 focus:ring-cyan-500 focus:outline-none" />
              {error && <p className="text-red-400 text-xs">{error}</p>}
              <button type="submit" disabled={loading} className="w-full bg-pulse-primary text-black py-3 rounded-xl font-bold text-sm disabled:opacity-50">{loading ? '...' : (lang === 'es' ? 'Cambiar contrasena' : 'Change password')}</button>
            </form>
          )}

          {step === 'done' && (
            <div className="text-center mt-6 space-y-4">
              <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center mx-auto"><Check size={32} className="text-green-400" /></div>
              <p className="text-sm">{message}</p>
              <Link to="/login" className="inline-block bg-pulse-primary text-black px-6 py-2 rounded-xl text-sm font-bold">{lang === 'es' ? 'Ir al login' : 'Go to login'}</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
